import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import bus from './utils/bus'
import './assets/css/main.css'
import { Empty, Button, Checkbox, CheckboxGroup, Icon, Dialog, Toast, NavBar, Uploader, Popup, ActionSheet, Tabs, Tab, Radio, RadioGroup, Cell, PullRefresh, List } from 'vant'
import 'vant/lib/empty/style'
import 'vant/lib/button/style'
import 'vant/lib/checkbox/style'
import 'vant/lib/checkbox-group/style'
import 'vant/lib/icon/style'
import 'vant/lib/dialog/style'
import 'vant/lib/nav-bar/style'
import 'vant/lib/uploader/style'
import 'vant/lib/toast/style'
import 'vant/lib/popup/style'
import 'vant/lib/action-sheet/style'
import 'vant/lib/tabs/style'
import 'vant/lib/tab/style'
import 'vant/lib/radio/style'
import 'vant/lib/radio-group/style'
import 'vant/lib/cell/style'
import 'vant/lib/pull-refresh/style'
import 'vant/lib/list/style'
Vue.use(Empty)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(NavBar)
Vue.use(Uploader)
Vue.use(Popup)
Vue.use(ActionSheet)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Cell)
Vue.use(PullRefresh)
Vue.use(List)
Vue.config.productionTip = false
Vue.prototype.$bus = bus
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
